<template>
  <div class="directory-list" id="directory-list">
    <header-cmp></header-cmp>
    <menu-cmp></menu-cmp>
    <div class="myMain directoryBox">
      <!-- 面包屑 -->
      <el-breadcrumb separator-class="el-icon-arrow-right " class="breadcrumb">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="title">
        <i class="line hidden-sm-and-down"></i>
        <h2>名录</h2>
      </div>
      <div class="infoBox">
        <ul>
          <li
            v-for="(item, index) in articleData"
            :key="index"
            @click="jumpDetail(item)"
          >
            <p v-html="removeHtmlStyle(item.content)" class="directoryInfo"></p>
            <img :src="item.img" :alt="item.title" />
          </li>
        </ul>
      </div>
    </div>
    <footer-cmp></footer-cmp>
  </div>
</template>

<script>
import headerCmp from "../components/common/header.vue";
import menuCmp from "../components/common/navMenu.vue";
import footerCmp from "../components/common/footer.vue";
import { getArticleList, getArticleDetail } from "@/api/home/index";
import { removeHtmlStyle } from "@/utils/removestyle";
export default {
  name: "directoryList",
  components: {
    headerCmp,
    menuCmp,
    footerCmp,
  },
  data() {
    return {
      articleParams: {
        category: 16,
      },
      articleData: [],
    };
  },
  created() {
    getArticleList(this.articleParams).then((res) => {
      this.articleData = res.data.list;
    });
  },
  methods: {
    removeHtmlStyle,
    jumpDetail(item) {
      console.log(item.id);
      // getArticleDetail({id:item.id}).then(res => {
      //   console.log('getArticleDetail',res)
      // })
    },
  },
};
</script>
<style lang="scss" scoped>
.directory-list {
  font-size: 14px;
  .title {
    display: flex;
    margin: 40px 0 30px 0;
    .line {
      display: inline-block;
      width: 4px;
      height: 28px;
      background: #da5351;
      margin-right: 20px;
    }
    h2 {
      width: 56px;
      height: 28px;
      font-size: 28px;
      font-weight: 400;
      color: #222222;
      line-height: 28px;
    }
  }
  .infoBox {
    padding: 0 20px 20px 20px;
    background-color: #fafafa;
    margin-bottom: 80px;
    border: 1px dashed #dddddd;
    border-radius: 4px;
    ul {
      li {
        font-size: 18px;
        padding: 14px 0;
        border-bottom: 1px dashed #dddddd;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .directoryInfo {
          ::v-deep p {
            font-size: 18px;
            word-break: break-all;
            white-space: pre-wrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
          }
        }
        img {
          height: 45px;
          width: 60px;
          padding: 6px 8px;
          background: #f0898b;
        }
      }
    }
  }
}

//移动端
@media screen and (max-width: 960px) {
  #directory-list {
    .directoryBox {
      margin-top: 0.56rem;
      .breadcrumb {
        display: none;
      }
      .title {
        margin: 0;
        padding: 0.14rem 0.16rem;
        h2 {
          font-size: 0.18rem;
          font-weight: 500;
          line-height: 0.24rem;
        }
      }
      .infoBox {
        padding: 0;
        background-color: #fff;
        margin-bottom: 0.8rem;
        border: none;
        border-radius: 0;
        ul {
          padding: 0 0.16rem;
          li {
            width: 100%;
            font-size: 0.14rem;
            font-weight: 400;
            color: #454545;
            line-height: 0.2rem;
            padding: 0.12rem 0;
            border-top: 0.01rem dashed #dddddd;
            border-bottom: 0.01rem dashed #dddddd;
            .directoryInfo {
              width: 2.52rem;
              font-size: 0.14rem;
            }
            img {
              width: 0.42rem;
              height: 0.3rem;
              padding: 0.1rem;
            }
          }
        }
      }
    }
    .footer {
      display: none;
    }
  }
}
</style>
